import React, { useCallback } from 'react'
import { I18n, CDNImage, hooks } from '@front/volcanion'
import { OptionUtils, UserUtils } from '@front/volcanion/utils'
import { CPUtils } from '@front/squirtle/utils'

import { Grid, Box } from '@mui/material'
import _ from 'lodash'

import { MenuSelectorField, ModelAutocompleteField, ModelMenuSelectorField, TextField } from '@front/squirtle'
import { MenuIcon } from '@front/squirtle/components/MenuSelector/component'

const PackageIcon = ({ option }) => <CDNImage name={option?.client_type_icon} category='packages' style={{ width: 20, height: 20 }} />

const TransportSection = ({ mode }) => {
  const transport_status_list = hooks.useTransportStatusList()

  const transportStatusOptions = _.map(transport_status_list, value => ({ label: I18n.t(`transport.status.${value}`), value }))

  const autocompleteMutatorDriver = useCallback(q => ({
    or: [
      { info: { user_client_id: { startsWith: q } } },
      { info: { first_name: { startsWith: q } } },
      { info: { last_name: { startsWith: q } } }
    ]
  }), [])

  const commercialPackageMutator = useCallback(cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp }), [])
  const driverMutator = useCallback(user => ({
    label: UserUtils.getFormatedName({ ...user?.info, designation: user?.customerinfo?.name }, { prefix: user?.info?.user_client_id }),
    ...user
  }), [])

  const optionsMutator = useCallback(elem => ({ label: OptionUtils.getLabel(elem), ...elem }), [])

  return (
    <Box flex={1}>
      <Grid container spacing={1}>
        <Grid size={4}>
          <ModelMenuSelectorField
            name={'mode'}
            label={I18n.t('ride.type')}
            model_name={'ridemode'}
            searchMode={'search'}
            labelKeys={['name_translated']}
            config={{
              initial_filter: {},
              sort: ['display_index ASC']
            }}
            multiple
          />
        </Grid>
        <Grid size={4}>
          <ModelMenuSelectorField
            name='commercial_formula'
            label={I18n.t('commercial_formula.label', { count: 1 })}
            model_name='commercialformula'
            labelKeys={['name']}
            searchMode={'search'}
            config={{
              initial_filter: {}
            }}
            multiple
            clearOnEmpty
          />
        </Grid>
        <Grid size={4}>
          <ModelMenuSelectorField
            name='commercial_package.commercial_package_id'
            label={I18n.t('commercialpackage.label', { count: 2 })}
            model_name='commercialpackage'
            searchMode={'search'}
            config={{
              initial_filter: {},
              mutator: commercialPackageMutator
            }}
            multiple
            clearOnEmpty
          >
            <MenuIcon><PackageIcon /></MenuIcon>
          </ModelMenuSelectorField>
        </Grid>
        <Grid hidden={mode !== 'order'} size={4}>
          <ModelMenuSelectorField
            name='assigned_transport.vehicle.type'
            label={I18n.t('vehicle.type')}
            model_name='vehicletype'
            labelKeys={['name_translated']}
            config={{
              initial_filter: {},
            }}
            searchMode='search'
            multiple
            clearOnEmpty
          />
        </Grid>
        <Grid hidden={mode !== 'order'} size={4}>
          <ModelMenuSelectorField
            name='vehicle_opts'
            label={I18n.t('options.vehicleoption.label', { count: 1 })}
            model_name={'vehicleoption'}
            searchMode='search'
            config={{
              initial_filter: {},
              mutator: optionsMutator
            }}
            multiple
            clearOnEmpty
          />
        </Grid>
        <Grid size={4}>
          <TextField name='assigned_transport.vehicle.info.plaque' label={I18n.t('vehicle.plaque', { count: 1 })} />
        </Grid>
        <Grid size={3}>
          <ModelAutocompleteField
            name={'assigned_transport.driver'}
            label={I18n.t('driver.search_multiple')}
            model_name={'user'}
            searchMode='search'
            searchQuery={'='}
            autocompleteMutator={autocompleteMutatorDriver}
            config={{
              forced_filter: { driverinfo: { '!': null } },
              populate: ['info', 'customerinfo'],
              mutator: driverMutator
            }}
          />
        </Grid>
        <Grid hidden={mode !== 'order'} size={3}>
          <ModelMenuSelectorField
            name='driver_opts'
            label={I18n.t('options.useroption.label', { count: 1 })}
            model_name='useroption'
            searchMode='search'
            config={{
              initial_filter: {},
              mutator: optionsMutator
            }}
            multiple
            clearOnEmpty
          />
        </Grid>
        <Grid size={3}>
          <MenuSelectorField
            name='assigned_transport.status'
            label={I18n.t('transportStatus.label', { count: -1 })}
            options={transportStatusOptions}
            multiple
            clearOnEmpty
          />
        </Grid>
        <Grid hidden={mode !== 'order'} size={3}>
          <ModelMenuSelectorField
            name={'reason'}
            label={I18n.t('order.reason')}
            model_name={'reason'}
            labelKeys={['name_translated']}
            config={{
              initial_filter: {},
              forced_filter: {
                type: ['cancel']
              },
              sort: ['display_index DESC']
            }}
            searchMode={'search'}
            allowNone={false}
            multiple
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(TransportSection)
